import moment from 'moment/moment';
import React from 'react'
import numberbeautify from '../../utils/numberbeautify';
import money_rounding from '../../utils/money_rounding';
import constant from '../../utils/constant';
import de from '../../utils/language_de';
import en from '../../utils/language_en';
import es from '../../utils/language_es';
import fr from '../../utils/language_fr';
import it from '../../utils/language_it';
import pt from '../../utils/language_pt';
import zh from '../../utils/language_zh';

// Statement template approximating the provided design using Tailwind CSS
// Static demo data is used to mirror the screenshot. Replace with props/state as needed.
const Statment_template_1 = ({statment_id,statment_number,statment_date,user_id,business_id,business_detail,client_detail,items,template,user_notification_token,localization}) => {
  var business_detaill=JSON.parse(business_detail);
  var client_detaill=JSON.parse(client_detail);
  var itemss=JSON.parse(items);
  const localizationn=localization=="zh"?zh:localization=="de"?de:localization=="en"?en:localization=="es"?es:localization=="fr"?fr:localization=="it"?it:localization=="pt"?pt:en;
  return (
    <div className="w-full bg-white text-black">
      <div className="max-w-4xl mx-auto px-6 pt-8 pb-16">
        {/* Header */}
        <div className="flex items-start justify-between gap-6">
          <div>
            <h1 className="text-2xl md:text-4xl tracking-tight poppins-semibold">{business_detaill?.business_name}</h1>
            <div className="mt-2 space-y-0.5 text-sm">
              <p className="text-[#666666] poppins-regular text-xs md:text-base">{business_detaill?.business_phone_1} - {business_detaill?.business_phone_2}</p>
              {business_detaill?.business_fax.trim()&&(<p className="text-[#666666] poppins-regular text-xs md:text-base">{localizationn?.fax}: {business_detaill?.business_fax}</p>)}
              {business_detaill?.business_street_1.trim()&&(<p className="text-[#666666] poppins-regular text-xs md:text-base">{business_detaill?.business_street_1}</p>)}
              {business_detaill?.business_street_2.trim()&&(<p className="text-[#666666] poppins-regular text-xs md:text-base">{business_detaill?.business_street_2}</p>)}
              {business_detaill?.business_city.trim()&&(<p className="text-[#666666] poppins-regular text-xs md:text-base">{business_detaill?.business_city}</p>)}
              {business_detaill?.business_country.trim()&&(<p className="text-[#666666] poppins-regular text-xs md:text-base">{business_detaill?.business_country}</p>)}
              {business_detaill?.business_email.trim()&&(<p className="text-[#666666] poppins-regular text-xs md:text-base">{business_detaill?.business_email}</p>)}
              {business_detaill?.business_website.trim()&&(<p className="text-[#666666] poppins-regular text-xs md:text-base">{business_detaill?.business_website}</p>)}
            </div>
          </div>

          {/* Simple heartbeat-like logo using SVG to match the red mark */}
          <div className="shrink-0 mt-2">
            <img src={business_detaill?.business_logo} alt="Logo" className="w-28 h-28 md:w-48 md:h-48" />
          </div>
        </div>

        {/* Title and meta */}
        <div className="mt-10">
          <h2 className="text-lg md:text-xl poppins-semibold">{localizationn?.statment_of_account}</h2>

          <div className="w-full flex">
            {/* Client block */}
            <div className="flex w-2/3">
              <div className='w-1/2'>
                <p className="text-[#666666] poppins-regular text-[10px] md:text-base">{client_detaill?.client_name}</p>
                <p className="text-[#666666] poppins-regular text-[9px] md:text-base">{client_detaill?.client_phone}</p>
                <p className="text-[#666666] poppins-regular text-[9px] md:text-base">{client_detaill?.client_mobile}</p>
                <p className="text-[#666666] poppins-regular text-[9px] md:text-base">{client_detaill?.client_email}</p>
              </div>
              <div className='w-1/2 mx-5'>
                <p className="text-[#666666] poppins-regular text-[9px] md:text-base">{client_detaill?.client_address_1}</p>
                <p className="text-[#666666] poppins-regular text-[9px] md:text-base">{client_detaill?.client_address_2}</p>
                <p className="text-[#666666] poppins-regular text-[9px] md:text-base">{client_detaill?.client_city}</p>
                <p className="text-[#666666] poppins-regular text-[9px] md:text-base">{client_detaill?.client_state} {client_detaill?.client_zip}</p>
                <p className="text-[#666666] poppins-regular text-[9px] md:text-base">{client_detaill?.client_country}</p>
              </div>
            </div>

            {/* Right meta list */}
            <div className="w-1/3">
              <div className='w-full flex justify-between'>
                <div className="text-[#666666] poppins-regular text-[8px] md:text-base">{localizationn?.from}:</div>
                <div className="text-right poppins-regular text-[8px] md:text-base">{itemss?.length>0?moment(itemss[0]?.created_date).format('YYYY-MM-DD'):"-"}</div>
              </div>
              <div className='w-full flex justify-between'>
                <div className="text-[#666666] poppins-regular text-[8px] md:text-base">{localizationn?.to}:</div>
                <div className="text-right poppins-regular text-[8px] md:text-base">{itemss?.length>0?moment(itemss[itemss?.length-1]?.created_date).format('YYYY-MM-DD'):"-"}</div>
              </div>
              <div className='w-full flex justify-between'>
                <div className="text-[#666666] poppins-regular text-[8px] md:text-base">{localizationn?.statment_date}:</div>
                <div className="text-right poppins-regular text-[8px] md:text-base">{moment(statment_date).format('YYYY-MM-DD')}</div>
              </div>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="mt-8 border border-black/70 overflow-hidden">
          <table className="w-full text-[8px] md:text-base">
            <thead>
              <tr className="bg-[#2C3E50] text-white">
                <th className="py-2 px-3 text-left border-black/50 poppins-regular">#</th>
                <th className="py-2 px-3 text-center border-black/50 poppins-regular">{localizationn?.date}</th>
                <th className="py-2 px-3 text-center border-black/50 poppins-regular">{localizationn?.amount}</th>
                <th className="py-2 px-3 text-center border-black/50 poppins-regular">{localizationn?.paid}</th>
                <th className="py-2 px-3 text-right poppins-regular">{localizationn?.due}</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-black/20">
            {itemss?.map((item,index)=>(
              <tr key={index}>
                <td className="py-2 px-3 text-left border-black/20 poppins-light">{item?.document_number}</td>
                <td className="py-2 px-3 text-center border-black/20 poppins-light">{moment(item?.created_date).format('YYYY-MM-DD')}</td>
                <td className="py-2 px-3 text-center border-black/20 poppins-light">{JSON.parse(item?.document_currency)?.symbol}{numberbeautify(money_rounding(item?.total_document_amount))}</td>
                {item?.document_type=="invoice"?
                  <td className="py-2 px-3 text-center border-black/20 poppins-light">{JSON.parse(item?.document_currency)?.symbol}{item?.payment_state=='paid'?numberbeautify(money_rounding(item?.total_document_amount)):numberbeautify(0)}</td>:
                  <td className="py-2 px-3 text-center border-black/20 poppins-light">-</td>
                }
                {item?.document_type=="invoice"?
                  <td className="py-2 px-3 text-right poppins-light">{JSON.parse(item?.document_currency)?.symbol}{item?.payment_state=='paid'?numberbeautify(0):numberbeautify(money_rounding(item?.total_document_amount))}</td>:
                  <td className="py-2 px-3 text-right poppins-light">-</td>
                }
              </tr>
            ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className='w-full h-52' />
    </div>
  )
}

export default Statment_template_1